import angular from "angular";
import modelFactory from './model.service';

let modelModule = angular.module('model.factory', [])
.factory('ModelFactory', modelFactory)
.name;

export default modelModule;



// WEBPACK FOOTER //
// ./client/app/common/factories/modelFactory/model.js